import { render } from "./RedeDeEnsinoPerfilDados.vue?vue&type=template&id=2cfc2e00&scoped=true&ts=true"
import script from "./RedeDeEnsinoPerfilDados.vue?vue&type=script&lang=ts"
export * from "./RedeDeEnsinoPerfilDados.vue?vue&type=script&lang=ts"

import "./RedeDeEnsinoPerfilDados.vue?vue&type=style&index=0&id=2cfc2e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cfc2e00"],['__file',"src/components/RedeDeEnsino/RedeDeEnsinoPerfilDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cfc2e00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cfc2e00', __exports__)) {
    api.reload('2cfc2e00', __exports__)
  }
  
  module.hot.accept("./RedeDeEnsinoPerfilDados.vue?vue&type=template&id=2cfc2e00&scoped=true&ts=true", () => {
    api.rerender('2cfc2e00', render)
  })

}


export default __exports__